import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "core-js/stable"; /* Polyfills */
// import "core-js/stable/promise"; /* Polyfills */
import "core-js/stable/global-this"; /* Polyfills */
if (!globalThis.origin)
{
    globalThis.origin = window.location.origin;
}
import "core-js/proposals/url"; /* Polyfills */
import "intersection-observer";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import configureStore from "./store/configureStore";
import { AppState } from "./store";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { decompressFromBase64 } from "lz-string";
import { ConnectedRouter } from "connected-react-router";
import { ErrorBoundary } from "./errors";
import BrowserSupport from "./aat/components/BrowserSupport/BrowserSupport";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const history = createBrowserHistory({ basename: baseUrl });

let initialState: AppState | undefined = undefined;

if (window.__PRELOADED_STATE__)
{
    const decompressed = decompressFromBase64(window.__PRELOADED_STATE__) as string;
    initialState = JSON.parse(decompressed);
    delete window.__PRELOADED_STATE__;
}

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(initialState, history);

ReactDOM.hydrate(
    <ErrorBoundary>
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <BrowserRouter>
                    <BrowserSupport>
                        <App />
                    </BrowserSupport>
                </BrowserRouter>
            </ConnectedRouter>
        </Provider>
    </ErrorBoundary>,
    document.getElementById("root"));